module.exports = __webpack_public_path__ + "img/img21.e4fc5593.svg";